import styled from 'styled-components'
import media from 'styled-media-query'

export const AsideFormStyled = styled.form`
	display: flex;
	flex-direction: column;
	// gap: 8px;
	margin-bottom: 2rem;
	position: relative;

	.close {
		background: ${({ theme }) => theme.colors.second};
		color: ${({ theme }) => theme.colors.main};
    	border-radius: 50%;
		font-size: 13px;
		width: 36px;
		height: 36px;
		padding: 0;
		justify-content: center;
		position: absolute;
		right: -28px;
		top: -26px;

		svg {
			font-size: 20px;
		}

		${media.lessThan('medium')`
			right: -14px;
			top: -14px;
    	`}
	}

	h2 {
		margin: 0 0 1rem;
	}

	sub {
		display: inline-block;
		font-size: 12px;
		line-height: 14px;
	}

	.flag {
		display: flex;
		justify-content: center;
		width: 71px;
		height: 71px;
		text-align: center;
		padding-top: 15px;
		right: -22px;
		top: -36px;
		position: absolute;

		${media.lessThan('medium')`
			right: -18px;
			top: -24px;
    	`}

		& > span {
			font-size: 12px;
			line-height: 12px;
			letter-spacing: 0;
			position: absolute;
			z-index: 20;

			& > svg {
				color: ${({ theme }) => theme.colors.main};
				font-size: 34px;
			}
		}

		& > svg {
			color: ${({ theme }) => theme.colors.second};
			font-size: 71px;
			width: 100%;
			top: 0;
			position: absolute;
			z-index: 10;
		}
	}

	.aside-tabs {
		display: flex;
		gap: 1px;
		margin-bottom: 0; 
		button {
			background: ${({ theme }) => theme.colors.fifth};
			border: 0;
			border-radius: 5px;
			border-bottom-right-radius: 0;
			border-bottom-left-radius: 0;
			color: ${({ theme }) => theme.colors.text.light};
			font-size: 13px;
			line-height: 21px;
			font-weight: 300;
			padding: 0.05rem 0.5rem;
			opacity: 0.5;
			transition: all 0.2s ease-in-out;

			&:last-child {
				border-left: 0;
			}

			&:first-child {
				border-right: 0;
			}

			&.active {
				font-weight: 600;
				opacity: 1;
			}
		}
	}

	.vpd {
		background: ${({ theme }) => theme.colors.fifth};
		border-radius: 5px;
		border-top-left-radius: 0;
		padding: 0.5rem;

		h3 {
			font-size: 18px;
			font-weight: 600;
			margin: 0 0 1rem;
			text-align: center;
		}

		.vpd-calculator {
			background: ${({ theme }) => theme.colors.first};
			border-radius: 5px;
			display: flex;
			flex-direction: column;
			gap: 8px;
			padding: 0.5rem;
			text-align: center;
			margin: 0 0 1rem;

			input {
				background: ${({ theme }) => theme.colors.fifth};
			}

			& > div {
				display: grid;
				gap: 8px;
				align-items: center;
				grid-template-columns: 60% calc(40% - 8px);

				.label {
					text-align: right;
				}

				strong {
					background: ${({ theme }) => theme.colors.fifth};
					border: 0;
					font-size: 15px;
					font-weight: 700;
					padding: 0.5rem;
					display:block;
				}
			}
		}

		.vpd-result {
			p {
				background: ${({ theme }) => theme.colors.fourth};
				display: inline;
				line-height: 28px;
				padding: 0.1rem 0;
				
				&.down {
					background: ${({ theme }) => theme.colors.second};
				}
				&.up {
					background: ${({ theme }) => theme.colors.second};
				}
			}
		}
	}

	.details {
		background: ${({ theme }) => theme.colors.fifth};
		border-radius: 5px;
		border-top-left-radius: 0;
		padding: 0.5rem;

		display: flex;
		gap: 8px;
		flex-direction: column;

		add-to-calendar-button {
			margin: 0 auto 1rem;
		}
		
		& > div {
			align-items: center;
			display: grid;
			grid-template-columns: calc(50% - 4px) calc(50% - 4px);
			gap: 8px;
	
			&:last-child {
				grid-template-columns: auto;
			}

			.label {
				text-align: right;
			}

			.input {
				align-items: center;

				&.double {
					display: grid;
					gap: 4px;
					grid-template-columns: 54px auto;
				}
			}

			.value {
				padding: 0.5rem;
			}
		}
	}


	input[type='text'],
	input[type='number'],
	input[type='date'],
	textarea,
	select {
    	background: ${({ theme }) => theme.colors.first};
		color: ${({ theme }) => theme.colors.text.light};
    	border: 0;
		font-size: 15px;
		font-weight: 400;
		padding: 0.5rem;
		width: 100%;

		&.title {
			background: ${({ theme }) => theme.colors.fifth};
			border-radius: 5px;
			font-size: 24px;
			font-weight: 400;
			padding: 0.5rem 1rem 0.75rem;
		}
	}

	select {
		option {
			-webkit-appearence: none;
			background: ${({ theme }) => theme.colors.third};
		}
	}

	textarea {
		line-height: 24px;
		min-height: 184px;
		margin-bottom: 1rem;

		&::-webkit-scrollbar {
			width: 6px;
		}
		
		&::-webkit-scrollbar-track {
			background: ${({ theme }) => theme.colors.main};
		}
		
		&::-webkit-scrollbar-thumb {
			background-color: ${({ theme }) => theme.colors.first};
			border: 2px solid ${({ theme }) => theme.colors.main};
		}
	}

	button {
		font-size: 15px;
		padding: 1rem;
	}
`
